import { get } from "lodash";
import { WordpressCredentialsDialogController } from "./wordpress-credentials-dialog.controller";

export class SendToWpButtonController {
    public static $inject: string[] = [
        "$mdDialog",
        "$mdMedia",
        "rewriteUrlImg",
        "toaster",
        "wordpressService"
    ];

    public isBusy: boolean = false;
    public isItemGalleryFormDisplayed: boolean = false;
    public isItemPast; // Binded
    public item; // Binded
    public itemGalleryName: string = "";
    public sale; // Binded

    private $mdDialog;
    private $mdMedia;
    private rewriteUrlImg;
    private toaster;
    private wordpressService;
    private wpUsername;
    private wpPassword;

    constructor(
        $mdDialog,
        $mdMedia,
        rewriteUrlImg,
        toaster,
        wordpressService
    ) {
        this.$mdDialog = $mdDialog;
        this.$mdMedia = $mdMedia;
        this.rewriteUrlImg = rewriteUrlImg;
        this.toaster = toaster;
        this.wordpressService = wordpressService;
    }

    public $onInit() {
        this._init();
    }

    public cancelSendItem() {
        this.itemGalleryName = "";
        this.isItemGalleryFormDisplayed = false;
    }

    public sendItemToWordpress() {
        // We ensure that onclick you have wp credentials in localstorage
        this._init();

        this.isItemGalleryFormDisplayed = false;
        this.item["isItemPast"] = this.isItemPast;

        this._sendItemToWordpress(this.item);
    }

    public sendToWordpress($event) {
        // We ensure that onclick you have wp credentials in localstorage
        this._init();

        if (this.wpUsername && this.wpPassword) {
            if (this.sale) {
                this._sendSaleToWordpress(this.sale);
            }
            if (this.item) {
                this.isItemGalleryFormDisplayed = true;
            }
        } else {
            this.$mdDialog.show({
                controller: WordpressCredentialsDialogController,
                controllerAs: "wordpressCredentialsCtrl",
                template: require("./wordpress-credentials-dialog.html"),
                targetEvent: $event,
                fullscreen: this.$mdMedia("xs")
            })
                .then(() => {
                    this._init();
                    if (this.sale) {
                        this._sendSaleToWordpress(this.sale);
                    }
                })
                .catch(() => angular.noop());
        }
    }

    private _init() {
        const wpUsername = localStorage.getItem("wpUsername");
        const wpPassword = localStorage.getItem("wpPassword");

        if (wpUsername && wpPassword) {
            this.wpUsername = wpUsername;
            this.wpPassword = wpPassword;
        }
    }

    private _sendItemToWordpress(item) {
        this.isBusy = true;
        this.toaster.toast({
            message: "Communication avec le mag'...",
            delay: 2000
        });

        if (item.medias[0]) {
            const rewritedMediasUrl = this.rewriteUrlImg.buildUrl(
                item.medias[0].url,
                {
                    transform: get(item.medias[0], "meta.transform", null),
                    width: 2048,
                    height: 1024,
                    cropMode: "fullFitIn"
                }
            );

            fetch(rewritedMediasUrl)
                .then(response => {
                    return response.blob();
                })
                .then(blob => {
                    this.wordpressService.sendItem(item, blob, this.itemGalleryName)
                        .then(() => {
                            this.toaster.toast({
                                message: "Lot envoyé",
                                delay: 2000
                            });
                        })
                        .catch(() => {
                            this.toaster.toast({
                                message: "Une erreur est survenue",
                                warn: true
                            });
                        })
                        .finally(() => this.isBusy = false);
                });
        }
    }

    private _sendSaleToWordpress(sale) {
        this.isBusy = true;
        this.toaster.toast({
            message: "Communication avec le mag'...",
            delay: 2000
        });

        this.wordpressService.sendSale(sale)
            .then(() => {
                this.toaster.toast({
                    message: "Vente envoyée",
                    delay: 2000
                });
            })
            .catch(() => {
                this.toaster.toast({
                    message: "Une erreur est survenue",
                    warn: true
                });
            })
            .finally(() => this.isBusy = false);
    }
}
